import React, {Component} from 'react';
import RedirectUriCell from "./RedirectUriCell";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';

class RedirectUriRow extends Component {

  static propTypes = {
    oidcRedirectUri: PropTypes.shape({
      redirectUri: PropTypes.string,
      redirectUriType: PropTypes.number,
    }),
    onOidcRedirectUrisUpdate: PropTypes.func,
  }
  handleOnOidcRedirectUrisUpdate = (value) => {
    this.props.onOidcRedirectUrisUpdate(value);
  }

  render() {
    return (
      <div className="pb-12">
        <RedirectUriCell
          className="oidc-entra-id-eam-redirect-uri-input form-control attributes-input"
          onOidcRedirectUrisUpdate={this.handleOnOidcRedirectUrisUpdate}
          cellData={{
            id: 0,
            type: "redirectUri",
            value: this.props.oidcRedirectUri.redirectUri,
            placeholder: messageConstants.OIDC_URI_PLACEHOLDER
          }}/>
      </div>
    );
  }
}

export default RedirectUriRow;
